import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MyParentCompanyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyParentCompanyQuery = { __typename?: 'Query', myParentCompany?: { __typename?: 'MyParentCompany', parentCompanyId: string, name: string, status: Types.ParentCompanyStatus, tenants: Array<{ __typename?: 'MyParentCompanyTenant', id: string, name: string }>, administrators: Array<{ __typename?: 'MyParentCompanyAdministrator', email: string, fusionAuthUserId: string }>, members: Array<{ __typename?: 'MyParentCompanyMember', email: string, fullName: string, fusionAuthUserId?: string | null, status: Types.UserStatus, tenantId: string, userId: string }> } | null };

export type MyParentCompanyDetailsFragment = { __typename?: 'MyParentCompany', parentCompanyId: string, name: string, status: Types.ParentCompanyStatus, tenants: Array<{ __typename?: 'MyParentCompanyTenant', id: string, name: string }>, administrators: Array<{ __typename?: 'MyParentCompanyAdministrator', email: string, fusionAuthUserId: string }>, members: Array<{ __typename?: 'MyParentCompanyMember', email: string, fullName: string, fusionAuthUserId?: string | null, status: Types.UserStatus, tenantId: string, userId: string }> };

export type MyParentCompanyMemberRowFragment = { __typename?: 'MyParentCompanyMember', email: string, fullName: string, fusionAuthUserId?: string | null, status: Types.UserStatus, tenantId: string, userId: string };

export const MyParentCompanyMemberRowFragmentDoc = new TypedDocumentString(`
    fragment MyParentCompanyMemberRow on MyParentCompanyMember {
  email
  fullName
  fusionAuthUserId
  status
  tenantId
  userId
}
    `, {"fragmentName":"MyParentCompanyMemberRow"});
export const MyParentCompanyDetailsFragmentDoc = new TypedDocumentString(`
    fragment MyParentCompanyDetails on MyParentCompany {
  parentCompanyId
  name
  status
  tenants {
    id
    name
  }
  administrators {
    email
    fusionAuthUserId
  }
  members {
    ...MyParentCompanyMemberRow
  }
}
    fragment MyParentCompanyMemberRow on MyParentCompanyMember {
  email
  fullName
  fusionAuthUserId
  status
  tenantId
  userId
}`, {"fragmentName":"MyParentCompanyDetails"});
export const MyParentCompanyDocument = new TypedDocumentString(`
    query MyParentCompany {
  myParentCompany {
    ...MyParentCompanyDetails
  }
}
    fragment MyParentCompanyDetails on MyParentCompany {
  parentCompanyId
  name
  status
  tenants {
    id
    name
  }
  administrators {
    email
    fusionAuthUserId
  }
  members {
    ...MyParentCompanyMemberRow
  }
}
fragment MyParentCompanyMemberRow on MyParentCompanyMember {
  email
  fullName
  fusionAuthUserId
  status
  tenantId
  userId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MyParentCompany: build.query<MyParentCompanyQuery, MyParentCompanyQueryVariables | void>({
      query: (variables) => ({ document: MyParentCompanyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMyParentCompanyQuery, useLazyMyParentCompanyQuery } = injectedRtkApi;
